export function calcHonoraire(valueTypeHonoraire, netBudgetaire, tlpe, valueInputHonoraire) {
  if (valueTypeHonoraire === 0) {
    return (netBudgetaire + tlpe) * parseFloat(valueInputHonoraire) / 100;
  }
  return parseFloat(valueInputHonoraire);
}

export function calcPrixTotal(budget) {
  return (budget.prixNet || 0)
    + (budget.tlpe || 0)
    + (budget.fraisTechnique || 0)
    + (budget.honoraires || 0)
    + (budget.honoraireFraisTraitement || 0);
}
